import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// TODO refactor, use the same way of sending error messages as on phone and dates
export function atLeastOneCheckboxCheckedValidator(checkboxNames: string[]): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const isAtLeastOneChecked = checkboxNames.some((name) => formGroup.get(name)?.value);

    if (!isAtLeastOneChecked) {
      return { atLeastOneCheckboxRequired: true };
    }

    return null;
  };
}
